import React, { Fragment } from "react";
import { Route, Switch } from "react-router-dom";
import { UncontrolledAlert } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import Login from "../Views/Login";
import { PrivateRoute } from "../Components/PrivateRoute";
import Main from "./main";
import Transfer from "../Views/Transfer";
import RegisterPartner from "../Views/RegisterPartner";

import "react-datetime/css/react-datetime.css";
import "react-tabulator/lib/styles.css" // required styles
// import "react-tabulator/lib/css/tabulator.min.css"; // theme
import "react-tabulator/lib/css/tabulator_bootstrap4.min.css" // theme
// import "../assets/DefChoice/tabulator-bootstrap.css" // theme

const App = (props) => {
  const isIE = window.MSCompatibleInfo != null;

  return (
    <Fragment>
       
      {isIE && (
        <UncontrolledAlert color="danger">
          <h4>
            <FontAwesomeIcon icon={faInfo} /> Alert
          </h4>
          Definitive Choice supports Chrome, Edge and Firefox browsers, please
          use one of these in order to log in the system.
        </UncontrolledAlert>
      )}
      {!isIE && (
        <Switch>
          <Route path="/login" component={Login}></Route>
          <Route exact path="/transfer/:guid" component={Transfer}></Route>
          <Route
            exact
            path="/registerPartner"
            component={RegisterPartner}
          ></Route>
          <PrivateRoute path="/" component={Main}></PrivateRoute>
          {/* <Redirect component=></Redirect> */}
          <Route component={Main}></Route>
        </Switch>
      )}
    </Fragment>
  );
};

export default App;
